(function(){
  var raiz = document.getElementById('hflp');
  if(!raiz) return;

  /* ══════════════ AISLAR LA LANDING ══════════════
     Sube desde #hflp hasta <body> y oculta, en cada nivel, todo hermano
     que no contenga la landing. Asi da igual como se llamen la cabecera,
     el pie o los widgets de las apps: si no son la landing, desaparecen.
     El banner de cookies queda siempre exento. */
  (function aislar(){
    var EXENTO = /cookie|consent|shopify-pc__banner|gdpr/i;
    var NO_TOCAR = {SCRIPT:1, STYLE:1, NOSCRIPT:1, LINK:1, TEMPLATE:1};

    function exento(el){
      if(NO_TOCAR[el.tagName]) return true;
      var firma = (el.id || '') + ' ' + (el.className && el.className.baseVal !== undefined ? el.className.baseVal : el.className || '');
      return EXENTO.test(firma);
    }

    var n = raiz;
    while(n && n.parentElement){
      var padre = n.parentElement;
      Array.prototype.slice.call(padre.children).forEach(function(hijo){
        if(hijo !== n && !exento(hijo)) hijo.style.setProperty('display','none','important');
      });
      // el contenedor que si lleva la landing pierde sus limites de ancho
      padre.style.setProperty('max-width','none','important');
      padre.style.setProperty('padding','0','important');
      if(padre === document.body) break;
      n = padre;
    }

    /* segunda pasada: widgets que las apps inyectan despues de cargar */
    var SOSPECHOSOS = '#smile-ui-container,[id^="smile-"],[class^="smile-"],'
      + '[id*="whatsapp"],[class*="whatsapp"],a[href*="api.whatsapp.com"],'
      + '#shopify-chat,.shopify-chat,.tidio-chat,#tidio-chat,'
      + '#gorgias-chat-container,#crisp-chatbox,[id^="attentive_"],[id*="privy"]';
    function barrer(){
      document.querySelectorAll(SOSPECHOSOS).forEach(function(el){
        if(raiz.contains(el)) return;
        var caja = el.closest('div,iframe,section') || el;
        caja.style.setProperty('display','none','important');
      });
    }
    barrer();
    if('MutationObserver' in window){
      var mo = new MutationObserver(barrer);
      mo.observe(document.body, {childList:true, subtree:false});
      setTimeout(function(){ mo.disconnect(); }, 15000);
    }
  })();

  raiz.querySelectorAll('video').forEach(function(v){
    if(!('IntersectionObserver' in window)) return;
    new IntersectionObserver(function(ent){
      ent.forEach(function(e){
        if(e.isIntersecting && e.intersectionRatio >= 0.4){ v.play().catch(function(){}); }
        else { v.pause(); }
      });
    },{threshold:[0,0.4]}).observe(v);
  });

  raiz.querySelectorAll('[data-son]').forEach(function(b){
    b.addEventListener('click', function(e){
      e.stopPropagation();
      var v = document.getElementById(b.dataset.son); if(!v) return;
      var activar = v.muted;
      raiz.querySelectorAll('video').forEach(function(o){ o.muted = true; });
      raiz.querySelectorAll('[data-son] span').forEach(function(s){ s.textContent = 'Sonido'; });
      if(activar){ v.muted = false; v.play().catch(function(){}); b.querySelector('span').textContent = 'Silenciar'; }
    });
  });

  /* Stories: 3 segundos por pantalla */
  var st = document.getElementById('hfStories');
  if(st){
    var slides = st.querySelectorAll('.hf-ig-slide');
    var barras = st.querySelectorAll('.hf-ui-ig-prog b');
    var U = [{u:'martin_ac',i:'M',h:'2 h'},{u:'j.deltoro',i:'J',h:'5 h'},{u:'alexrmz__',i:'A',h:'8 h'}];
    var i = 0, DUR = 3000, tempo = null;
    function paso(){
      slides.forEach(function(s,n){ s.classList.toggle('on', n === i); });
      barras.forEach(function(b,n){ b.style.transition='none'; b.style.width = (n < i) ? '100%' : '0%'; });
      var b = barras[i];
      if(b){ void b.offsetWidth; b.style.transition='width '+DUR+'ms linear'; b.style.width='100%'; }
      var u = U[i] || U[0];
      var a = st.querySelector('[data-ig="user"]'), c = st.querySelector('[data-ig="ini"]'), d = st.querySelector('[data-ig="hora"]');
      if(a) a.textContent = u.u; if(c) c.textContent = u.i; if(d) d.textContent = u.h;
      i = (i + 1) % slides.length;
    }
    function on(){ if(!tempo){ paso(); tempo = setInterval(paso, DUR); } }
    function off(){ clearInterval(tempo); tempo = null; }
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(e){ e[0].isIntersecting ? on() : off(); },{threshold:0.3}).observe(st);
    } else { on(); }
  }

  /* ══════════════ EVENTOS DE META ══════════════
     AVISO IMPORTANTE:
     Esto es SOLO el pixel de navegador. La API de Conversiones (CAPI) es
     servidor-a-servidor y NO puede implementarse desde el HTML de una
     landing: la envia el canal de Meta de Shopify o una integracion propia.
     El eventID que se genera aqui existe para que, cuando CAPI mande el
     mismo evento, Meta pueda deduplicarlos. Para que sirva, el evento de
     servidor tiene que reusar ESE MISMO eventID.

     Ademas: si el pixel se carga por el canal de Meta de Shopify, corre en
     un web pixel aislado y window.fbq NO existe aqui. En ese caso nada de
     esto dispara. Verificar en Events Manager > Probar eventos. */

  var MONEDA = 'EUR';

  /* valor por enlace de carrito · mantener sincronizado con los precios */
  var OFERTAS = {
    '/cart/39726797291715:1':                        {v:31.99, ids:['39726797291715'],                   n:'Handsomefyer'},
    '/cart/39726797291715:2':                        {v:59.99, ids:['39726797291715'],                   n:'Handsomefyer x2'},
    '/cart/39726797291715:1,39990746939587:1':       {v:59.99, ids:['39726797291715','39990746939587'],  n:'Handsomefyer + Handsomefyer Sun'},
    '/cart/39755308892355:1':                        {v:31.99, ids:['39755308892355'],                   n:'Handsomefyer Xtra'},
    '/cart/39990746939587:1':                        {v:31.99, ids:['39990746939587'],                   n:'Handsomefyer Sun'}
  };

  function idEvento(){ return 'hf-' + Date.now() + '-' + Math.random().toString(36).slice(2,10); }

  /* ViewContent al cargar */
  if(window.fbq){
    fbq('track','ViewContent',{
      content_name:'Handsomefyer',
      content_type:'product',
      content_ids:['39726797291715'],
      content_category:'LP Handsomefyer',
      value:31.99,
      currency:MONEDA
    },{eventID:idEvento()});
  }

  /* 50% de scroll: senal de interes */
  var mitad = false;
  window.addEventListener('scroll', function(){
    if(mitad) return;
    var h = document.documentElement;
    if((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.5){
      mitad = true;
      if(window.fbq) fbq('trackCustom','ScrollMitad',{pagina:'lp-handsomefyer'});
      if(window.dataLayer) dataLayer.push({event:'scroll_50', pagina:'lp-handsomefyer'});
    }
  }, {passive:true});

  /* AddToCart al pulsar cualquier boton de compra.
     NO se dispara InitiateCheckout: el permalink lleva al checkout y el
     pixel de Shopify ya emite ese evento alli. Emitirlo aqui lo duplica. */
  raiz.querySelectorAll('a[href^="/cart/"]').forEach(function(a){
    a.addEventListener('click', function(){
      var href = (a.getAttribute('href') || '').split('?')[0];
      var o = OFERTAS[href];
      if(!o){
        var ids = href.match(/\d{10,}/g) || [];
        o = {v:0, ids:ids, n:ids.join(' + ')};
      }
      var eid = idEvento();
      var datos = {
        content_type:'product',
        content_ids:o.ids,
        content_name:o.n,
        value:o.v,
        currency:MONEDA,
        num_items:o.ids.length
      };
      if(window.fbq) fbq('track','AddToCart', datos, {eventID:eid});
      if(window.dataLayer) dataLayer.push({event:'add_to_cart', valor:o.v, items:o.ids, destino:href, event_id:eid});
    });
  });
})();